<template>
  <div>
    <div class="datacontent common_radius">
      <div class="firstrow">
        <div class="nav_group">
          <span class="nav_label">数据源</span>
          <el-select v-model="dataSet" placeholder="请选择数据源">
            <el-option
              v-for="item in dataSetList"
              :key="item.datasetCode"
              :label="item.datasetName"
              :value="item.datasetCode"
            >
            </el-option>
          </el-select>
        </div>
        <ct-button class="search-btn" type="primary" :btn-click="search"
          >查询</ct-button
        >
      </div>
      <div class="info-wrapper">
        <div class="echart-content">
          <echart
            :option="option"
            :divStyle="{ height: '344px', width: '600px' }"
          ></echart>
          <div class="plus-content" v-if="a">
            <div class="text-box">
              y={{ this.a }}x+{{ this.b }} <br />
              R²={{ this.RSquare }}
            </div>
          </div>
        </div>
        <div v-if="tableData && tableData.length > 0" class="table_wrapper">
          <el-table
            ref="singleTable"
            :data="tableData"
            style="width: 100%"
            row-key="channelid"
            @current-change="handleCurrentChange"
            :header-cell-style="{
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#444455',
              backgroundColor: 'rgb(180, 211, 238)'
            }"
            border
            :row-class-name="tableRowClassName"
          >
            <el-table-column width="60" align="center">
              <template slot-scope="scope">
                <el-radio class="radio" v-model="radio" :label="scope.$index">{{
                  null
                }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="heights" label="高度"></el-table-column>
            <el-table-column prop="value" label="R²"></el-table-column>
          </el-table>
        </div>
      </div>
      <div class="condition_wrapper">
        <div class="nav_label">
          应用通道
        </div>
        <div
          class="condition_group"
          v-if="channelList && channelList.length > 0"
        >
          <div class="condition_item-wrapper">
            <searchCondition
              :options="channelList"
              v-model="checkSpeeds"
              labelProps="heights"
              valueProps="channelId"
            ></searchCondition>
          </div>
        </div>
        <div class="channel-btn">
          <ct-button type="primary" :btn-click="apply">应用</ct-button>
          <ct-button :btn-click="resetMCPCorrectData">重置</ct-button>
        </div>
      </div>
      <div class="content" v-if="showDetail">
        <el-menu
          :default-active="activeIndex + ''"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#555555"
        >
          <el-menu-item
            v-for="item in menuList"
            :key="item.channelId"
            :index="item.channelId + ''"
            >{{ item.heights }}</el-menu-item
          >
        </el-menu>

        <div class="content-radio">
          <el-radio v-model="sector" label="1">分扇区订正</el-radio>
        </div>
        <el-table
          ref="multipleTable"
          :data="sectionPartitionDatas"
          tooltip-effect="dark"
          style="width: 100%"
          :cell-class-name="checkbox"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column
            prop="sectionPartitionDegrees"
            label="扇区"
            width="160px"
          ></el-table-column>
          <el-table-column prop="merra20" label="MERRA20"></el-table-column>
          <el-table-column prop="merra" label="MERRA代表年"></el-table-column>
          <el-table-column prop="a" label="intercept"></el-table-column>
          <el-table-column prop="b" label="slop"></el-table-column>
          <el-table-column
            prop="correlationCoefficient"
            label="R²"
          ></el-table-column>
          <el-table-column prop="correctNum" label="订正量"></el-table-column>
          <el-table-column
            prop="windSpeedAvg"
            label="订正前风速（m/s）"
            width="130px"
          ></el-table-column>
          <el-table-column
            prop="correctSpeedAvg"
            label="订正后风速（m/s）"
            width="130px"
          ></el-table-column>
        </el-table>
        <el-table :data="revisionData" style="width: 100%" align="center">
          <el-table-column prop="name" label="订正项"></el-table-column>
          <el-table-column
            prop="windSpeedAvg"
            label="订正前风速（m/s）"
          ></el-table-column>
          <el-table-column
            prop="mcpCorrectSpeedAvg"
            label="订正后风速（m/s）"
          ></el-table-column>
        </el-table>
        <div class="content-radio">
          <el-radio v-model="sector" label="2">全扇区订正</el-radio>
        </div>
        <el-table
          :data="allSectionPartitionDatas"
          style="width: 100%"
          align="center"
        >
          <el-table-column
            prop="sectionPartitionDegrees"
            label="扇区"
            width="160px"
          ></el-table-column>
          <el-table-column prop="merra20" label="MERRA20"></el-table-column>
          <el-table-column prop="merra" label="MERRA代表年"></el-table-column>
          <el-table-column prop="a" label="intercept"></el-table-column>
          <el-table-column prop="b" label="slop"></el-table-column>
          <el-table-column
            prop="correlationCoefficient"
            label="R²"
          ></el-table-column>
          <el-table-column prop="correctNum" label="订正量"></el-table-column>
          <el-table-column
            prop="windSpeedAvg"
            label="订正前风速（m/s）"
            width="130px"
          ></el-table-column>
          <el-table-column
            prop="correctSpeedAvg"
            label="订正后风速（m/s）"
            width="130px"
          ></el-table-column>
        </el-table>
        <div class="btn-save">
          <ct-button
            type="primary"
            :btn-click="saveMCPCorrectData"
            :disabled="!sector"
            size="small"
            >保存</ct-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import isEqual from 'lodash/isEqual';
import searchCondition from '../components/searchContidions';
export default {
  data() {
    return {
      showDetail: false,
      activeIndex: '0',
      option: {},
      tableData: [],
      radio: 0,
      sector: '1',
      selected: {},
      checkList: [],
      channelList: [],
      menuList: [],
      data: [],
      correctData: {},
      currentChannelId: '',
      sectionPartitionDatas: [],
      allSectionPartitionDatas: [],
      multipleSelection: [],
      revisionData: [],
      a: null,
      b: null,
      RSquare: null,
      dataSet: '',
      dataSetList: [],
      selectTowerId: '',
      selectVersionId: '',
      checkSpeeds: []
    };
  },
  watch: {
    currentChannelId() {
      this.correctData = this.data.filter(item => {
        return item.channelId == this.currentChannelId;
      });
      this.sectionPartitionDatas =
        this.correctData[0] && this.correctData[0].sectionPartitionDatas;
      this.allSectionPartitionDatas =
        this.correctData[0] && this.correctData[0].allSectionPartitionDatas;
      this.revisionData = [
        {
          name: '平均风速',
          windSpeedAvg: this.correctData[0] && this.correctData[0].windSpeedAvg,
          mcpCorrectSpeedAvg:
            this.correctData[0] && this.correctData[0].mcpCorrectSpeedAvg
        }
      ];
    },
    towerInfo: {
      handler(newVal, oldValue) {
        if (!isEqual(newVal, oldValue)) {
          this.showDetail = false;
          this.radio = 0;
          this.getCorrectData(newVal);
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.getCorrectDataSet();
    await this.getCorrectData(this.towerInfo);
    // this.RSquare = this.tableData && this.tableData[0].value;
  },
  computed: {
    selectNums() {
      return this.sectionPartitionDatas
        .map(item => {
          return item.sectionNum;
        })
        .join();
    },
    towerInfo: function() {
      return this.$store.state.WindData.towerObj;
    }
  },
  methods: {
    // handleSelectionChange(val) {
    //   this.multipleSelection = val;
    // },
    checkbox(row) {
      if (row.row.sectionPartitionDegrees === '各扇区平均') {
        return 'mycell';
      }
    },
    async saveMCPCorrectData() {
      await this.$postForm({
        url: '/winddata/dataProcess/saveMCPCorrectData',
        module: 'windData',
        data: {
          channelId: this.currentChannelId,
          selectNums: this.sector === '1' ? '0' : '360',
          versionId: this.selectVersionId
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      // this.showDetail = false;
      this.sector = '1';
      // this.checkList = [];
    },
    async handleCurrentChange(row) {
      //console.log(row, 'row.....');
      this.radio = this.tableData.indexOf(row);
      this.selected = row;
      this.RSquare = row.value;
      await this.getCorrectData(this.towerInfo, row.channelid);
    },
    async resetMCPCorrectData() {
      let checkedList = this.getCheckedList();
      if (checkedList.length <= 0) {
        return this.$message({
          message: '请至少选择一个通道',
          type: 'error'
        });
      }
      await this.$postForm({
        url: '/winddata/dataProcess/resetMCPCorrectData',
        module: 'windData',
        data: {
          channelIds: checkedList.join(),
          towerId: this.selectTowerId,
          versionId: this.selectVersionId
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      this.checkSpeeds = [];
      this.showDetail = false;
    },
    async apply() {
      let checkedList = this.getCheckedList();
      checkedList.sort((a, b) => a - b);
      if (checkedList <= 0) {
        return this.$message({
          message: '请至少选择一个通道',
          type: 'error'
        });
      }
      this.showDetail = true;
      this.menuList = [];
      checkedList.forEach(id => {
        let temp = this.channelList.find(v => v.channelId === id);
        this.menuList.push(temp);
      });

      this.activeIndex = checkedList[0] + '';
      this.currentChannelId = checkedList[0];

      const { data } = await this.$postForm({
        url: '/winddata/dataProcess/MCPCorrectData',
        module: 'windData',
        data: {
          channelIds: checkedList.join(),
          towerId: this.selectTowerId,
          versionId: this.selectVersionId,
          dataSet: this.dataSet
        },
        showLoading: true,
        showError: true
      });
      this.data = data.resDataList || [];
      this.correctData = this.data.filter(item => {
        return item.channelId == this.activeIndex;
      });
      //console.log(this.correctData, 'this.correctData');
      this.sectionPartitionDatas =
        this.correctData[0] && this.correctData[0].sectionPartitionDatas;
      this.allSectionPartitionDatas =
        this.correctData[0] && this.correctData[0].allSectionPartitionDatas;
      this.revisionData = [
        {
          name: '平均风速',
          windSpeedAvg: this.correctData[0] && this.correctData[0].windSpeedAvg,
          mcpCorrectSpeedAvg:
            this.correctData[0] && this.correctData[0].mcpCorrectSpeedAvg
        }
      ];
    },
    handleSelect(channelId) {
      this.currentChannelId = channelId;
      //console.log(channelId, 'channelId...');
    },
    async getCorrectDataSet() {
      const { data } = await this.$fetch.get(
        '/winddata/dataProcess/getDataSet',
        {
          module: 'windData'
        }
      );
      let dataSetList = data.dataSetList;
      this.dataSetList = dataSetList;
      this.dataSet = dataSetList[0] && dataSetList[0].datasetCode;
    },
    async getCorrectData(towerInfo, id) {
      let { towerId, versionId } = towerInfo || {};
      if (!towerId && !versionId) return;
      this.selectTowerId = towerId;
      this.selectVersionId = versionId;
      const { data } = await this.$fetch.get(
        '/winddata/dataProcess/getCorrectData',
        {
          module: 'windData',
          params: {
            channelId: id || 0,
            towerId: this.selectTowerId,
            versionId: this.selectVersionId,
            dataSet: this.dataSet
          },
          showLoading: true,
          showError: true
        }
      );
      let {
        correlationList,
        avgScatterDataList,
        factorList,
        channelList,
        a,
        b
      } = data;
      this.a = a;
      this.b = b;
      this.tableData = factorList ? factorList : this.tableData;

      if (channelList) {
        this.checkSpeeds = channelList.map(v => v.channelId);
      }
      this.channelList = channelList ? channelList : this.channelList;
      if (!id) {
        this.RSquare = this.tableData && this.tableData[0].value;
      }
      const markLineOpt = {
        animation: false,
        lineStyle: {
          type: 'solid',
          color: '#0477a1'
        },
        data: [
          [
            {
              coord: avgScatterDataList && avgScatterDataList[0],
              symbol: 'none'
            },
            {
              coord: avgScatterDataList && avgScatterDataList[1],
              symbol: 'none'
            }
          ]
        ]
      };
      const option = {
        grid: { top: '10%', left: '7%', width: '72%', height: '80%' },
        tooltip: {
          show: false,
          alwaysShowContent: false
        },
        backgroundColor: '#fff',
        xAxis: {
          name: 'Merra2数据(m/s)',
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#222233'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#222233' //这里用参数代替了
            }
          }
        },
        yAxis: {
          name: '测风数据(m/s)',
          type: 'value',
          splitLine: {
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#000'
            }
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: '#222233' //这里用参数代替了
            }
          }
        },
        series: [
          {
            name: '风速',
            type: 'scatter',
            symbolSize: 3,
            emphasis: {
              label: {
                show: false,
                position: 'left',
                color: '#222233',
                fontSize: 16
              }
            },
            data: correlationList,
            markLine: markLineOpt
          }
        ]
      };
      this.option = option;
    },
    search() {
      this.getCorrectData(
        this.towerInfo,
        this.selected && this.selected.channelid
      );
    },
    tableRowClassName({ row, rowIndex }) {
      console.log(row);
      if (rowIndex % 2 !== 0) {
        return 'custom-table-row-odd';
      } else {
        return 'custom-table-row-even';
      }
    },
    getCheckedList() {
      return this.checkSpeeds;
    }
  },
  components: {
    searchCondition
  }
};
</script>
<style lang="less" scoped>
.datacontent {
  padding: 15px;
  box-sizing: border-box;
  width: 100%;
  background: rgb(240, 245, 250);
  .nav_label {
    font-size: 16px;
    font-weight: bold;
    color: #222234;
    padding: 0 0 2px 8px;
    border-left: 2px solid #077cac;
    line-height: 18px;
    margin-right: 10px;
  }
  .search-btn {
    margin-left: 10px;
  }
  .nav_group {
    display: flex;
    align-items: center;
  }
  .firstrow {
    display: flex;
    align-items: center;
  }
  /deep/.info-wrapper {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
    height: 344px;
    .echart-content {
      display: flex;
      background: #fff;
      border-radius: 8px;
      margin-right: 12px;
      position: relative;

      .plus-content {
        // width: 54px;
        flex: 1;
        font-size: 14px;
        color: #888899;
        line-height: 38px;
      }
      .text-box {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .table_wrapper {
      flex: 1;
    }
  }
  .condition {
    &_wrapper {
      border-radius: 8px;
      position: relative;
    }
    &_group {
      display: flex;
      margin-top: 12px;

      &:first-child {
        margin-bottom: 20px;
      }
    }
    &_label {
      font-size: 16px;
      font-weight: bold;
      color: #222233;
      margin-right: 10px;
      display: inline-block;
      height: 32px;
      line-height: 32px;
      width: 70px;
      text-align: right;
    }
    &_item {
      width: 180px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #fff;
      border: 1px solid
        linear-gradient(90deg, rgba(8, 120, 191, 0.11), rgba(0, 86, 170, 0.11))
        1 1;
      border-radius: 6px;
      display: inline-block;
      cursor: pointer;
      margin: 0 12px 8px 0;
      &.active {
        background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
        .text {
          color: #fff;
        }
        .checked {
          display: inline-block;
        }
      }
      .text {
        color: #888899ff;
        font-size: 14px;
        font-weight: bold;
      }
      .checked {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50px;
        background: rgb(240, 245, 250);
        text-align: center;
        line-height: 20px;
        margin-right: 12px;
        display: none;
        i {
          font-size: 14px;
          color: #0057aaff;
        }
      }
      &-wrapper {
        flex: 1;
      }
    }
  }

  .channel-btn {
    text-align: right;
    span:first-child {
      margin-right: 20px;
    }
  }

  /deep/.content {
    width: 100%;
    min-height: 400px;
    margin-top: 15px;
    // background-color: @bgColor;
    // padding: 15px;

    .el-menu.el-menu--horizontal {
      border-bottom: none;
      margin-bottom: 5px;
      .el-menu-item {
        line-height: 30px;
        height: 30px;
        color: #ffffff;
        border: none;
        // border: 1px solid #ffffff;
        &.is-active {
          background-color: #3271a1 !important ;
        }
      }
    }
    .btn-save {
      text-align: right;
      margin-top: 20px;
      span {
        display: inline-block;
      }
    }
    .content-radio {
      margin: 15px 0;
    }
  }
}
</style>
